import type { CncApp } from '@/types';

export const CNC_APPS: CncApp[] = [
  {
    id:          'nc-manager',
    name:        'NC Manager',
    description: 'Supervisors open a non-conformity straight from the floor: voice dictation in their own language, photos attached, automatic routing to the quality department for analysis and handling. No paperwork.',
    icon:        'AlertTriangle',
    colorVar:    'var(--color-reagir)',
    colorRgbVar: 'var(--color-reagir-rgb)',
    tag:         'Voice · Photos · ERP',
  },
  {
    id:          'expeditions',
    name:        'Shipping Management',
    description: 'Order number → matching parts pulled from the ERP → dimensions, weight and photos → shipping documents generated automatically and offices notified. All of it centralized in Teams.',
    icon:        'Package',
    colorVar:    'var(--color-anticiper)',
    colorRgbVar: 'var(--color-anticiper-rgb)',
    tag:         'ERP · Auto docs · Teams',
  },
  {
    id:          'gantt',
    name:        'Production Gantt',
    description: 'Production planning wired to the Notixia ERP (times taken from quotes) and to Leankit (production Kanban). A full Gantt view with live priority and lead-time management.',
    icon:        'GanttChart',
    colorVar:    'var(--color-temps)',
    colorRgbVar: 'var(--color-temps-rgb)',
    tag:         'ERP · LeanKit · Gantt',
  },
  {
    id:          'dashboard',
    name:        'Management Dashboard',
    description: 'A fully interactive company dashboard: revenue, sales, quality KPIs, maintenance, delays, production, quotes — all tied directly to the ERP database. It replaces PowerBI.',
    icon:        'LayoutDashboard',
    colorVar:    'var(--color-ameliorer)',
    colorRgbVar: 'var(--color-ameliorer-rgb)',
    tag:         'KPIs · ERP DB · Interactive',
  },
  {
    id:          'cerveau',
    name:        'Company Brain',
    description: 'An AI knowledge base connected to ERP data (quality, maintenance, production). It makes AI adoption workable and produces reliable technical documents from the plant’s real data.',
    icon:        'Brain',
    colorVar:    'var(--color-ciel)',
    colorRgbVar: 'var(--color-ciel-rgb)',
    tag:         'RAG · AI · ERP · Docs',
  },
  {
    id:          'dossier-agentique',
    name:        'Agentic Quality Package',
    description: 'Twelve specialized AI agents orchestrated as a pipeline: parsing customer requirements, reading purchase orders, checking CoCs, mill tests and NDT reports, annotating and renaming every document, then assembling the final package to that customer’s specific requirements. The CNC Brain orchestrates all of it — no human step in between.',
    icon:        'Network',
    colorVar:    'var(--color-temps)',
    colorRgbVar: 'var(--color-temps-rgb)',
    tag:         '12 agents · RAG · AI orchestration',
    isFeatured:  true,
    stats: [
      { value: '12',     label: 'Specialized agents' },
      { value: '20 min', label: 'Complete package'   },
      { value: '200',    label: 'Pages generated'    },
      { value: 'A→Z',    label: 'No human step'      },
    ],
  },
  {
    id:          'qms',
    name:        'Integrated QMS',
    description: 'A complete quality system tied to the ERP: quality steering, ISO 9001 audit management, measuring-instrument tracking (calibration), health-and-safety records — centralized and traceable.',
    icon:        'ShieldCheck',
    colorVar:    'var(--color-maitrise)',
    colorRgbVar: 'var(--color-maitrise-rgb)',
    tag:         'ISO 9001 · Safety · Metrology',
  },
];
